export const createCite = (className, text = ``) => {
  const cite = document.createElement(`cite`);
  cite.className = className;
  cite.innerHTML = text;

  return cite;
};
